module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top_text"
  }, [_c('v-icon', [_vm._v("beenhere")]), _c('span', [_vm._v("지역별 리포트")]), _vm._v(" "), _c('div', {
    staticClass: "select_ad"
  }, _vm._l((_vm.radioData), function(data, key, index) {
    return _c('div', {
      key: key,
      staticClass: "select"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkRadio),
        expression: "checkRadio"
      }],
      key: index,
      attrs: {
        "type": "radio",
        "name": "ad_radio"
      },
      domProps: {
        "value": key,
        "checked": _vm._q(_vm.checkRadio, key)
      },
      on: {
        "change": [function($event) {
          _vm.checkRadio = key
        }, _vm.radioClick]
      }
    }), _vm._v(" "), _c('span', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.rTextClick(key)
        }
      }
    }, [_vm._v(_vm._s(key))])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "topTableWrap"
  }, [_c('GeoTable', {
    attrs: {
      "checkRadio": _vm.checkRadio,
      "viewData": _vm.viewData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d273cad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/geo/GeoImp.vue
// module id = 857
// module chunks = 1